import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const FlightStatusApi = {
  index(query) {
    return http
      .get(`${orgPath()}/segments/air/status`, {
        cancelable: true,
        params: query,
      })
      .then((response) => {
        if (response.status === 204) {
          return [];
        } else {
          return response.data;
        }
      })
      .catch((error) => {
        if (error.message !== 'canceled') {
          throw error;
        }
      });
  },

  show(id) {
    return http.get(`${orgPath()}/segments/air/${id}/status`).then((response) => response.data);
  },
};

// Mock Objects
// const outlook = {
//   Status: '', // 'Unknown', 'On Time', 'Advisory', 'Warning'
//   Departure_score: '', // 'UNSCORED', 'GREEN', 'YELLOW', 'RED'
//   Arrival_score: ''
// };

// const status = {
//   Segment_id: '',
//   Status: '', // 'On Time', 'Delayed', 'Redirected', 'Diverted', 'Canceled', 'Landed', 'Unknown'
//   Departure_datetime: '',
//   Departure_datetime_estd: '',
//   Departure_datetime_actual: '',
//   Arrival_datetime: '',
//   Arrival_datetime_estd: '',
//   Arrival_datetime_actual: '',
//   outlook: outlook
// };

// const statusus = {}
